import React, {
  ComponentType,
  useState
} from 'react'
import {
  Button,
  Icon,
  Popup,
  Segment
} from 'semantic-ui-react'
// Local
import {
  ENCOUNTER,
  shouldRenderReskin2025
} from '../../../constant'
import { Encounter } from '../../authenticated/types'
import ReveleerButton from '../../common/ReveleerButton'
import { ObjectValues } from '../../../types/types'

const SafeSegment = Segment as unknown as ComponentType<any>

type EncounterStatus = ObjectValues<typeof ENCOUNTER.STATUS> | null | undefined

type Props = {
  encounter?: Encounter | undefined
  mode?: string | undefined
  onClick: (status: keyof typeof ENCOUNTER.STATUS) => void
}

function EncounterIgnoreButton(
  props: Props
): JSX.Element | null {
  const {
    encounter,
    mode = 'left',
    onClick
  } = props

  const [
    encounterStatusState,
    setEncounterStatusState
  ] = useState<EncounterStatus>(encounter && encounter.status)

  const onClickFn = () => {
    const newStatus = encounterStatusState === ENCOUNTER.STATUS.IGNORED
      ? ENCOUNTER.STATUS.PLANNED
      : ENCOUNTER.STATUS.IGNORED
    setEncounterStatusState(newStatus)
    onClick(newStatus)
  }

  if (mode !== 'left') return null

  const popupTxt = 'Mark Encounter Ignored. If there is no intent to work an' +
    ' encounter and move it to Ready for Physician, marking the encounter' +
    ' ignored will remove it from all work lists.'

  if (encounterStatusState === ENCOUNTER.STATUS.IGNORED) {
    return (
      <SafeSegment
        attached
        compact
        className="left-segment"
      >
        <div className="left-title-center">
          <Popup
            content="Mark Patient Encounter as Planned"
            mouseEnterDelay={ 1000 }
            trigger={
              shouldRenderReskin2025
                ? (
                  <ReveleerButton
                    buttonLabel="Undo Encounter Ignore"
                    buttonSize="small"
                    buttonType="secondary"
                    id="encounter-ignore-undo"
                    isDisabled={ false }
                    onClick={ onClickFn }
                    type="submit"
                  />
                )
                : (
                  <Button
                    id="encounter-ignore-undo"
                    type="submit"
                    onClick={ onClickFn }
                  >
                    <Icon name="undo" />
                    Undo Encounter Ignore
                  </Button>
                )
            }
          />
        </div>
      </SafeSegment>
    )
  }
  return (
    <SafeSegment
      attached
      compact
      className="left-segment"
    >
      <div className="left-title-center">
        <div>
          <span>
            Mark encounter Ignored and remove it from all work lists.
          </span>
        </div>
        <div className="m-1-top">
          <Popup
            content={ popupTxt }
            mouseEnterDelay={ 500 }
            trigger={
              shouldRenderReskin2025
                ? (
                  <ReveleerButton
                    buttonLabel="Ignore Encounter"
                    buttonSize="small"
                    buttonType="secondary"
                    id="encounter-ignore"
                    isDisabled={ false }
                    onClick={ onClickFn }
                    type="submit"
                  />
                )
                : (
                  <Button
                    id="encounter-ignore"
                    type="submit"
                    onClick={ onClickFn }
                  >
                    <Icon name="cut" />
                    Ignore Encounter
                  </Button>
                )
            }
          />
        </div>
      </div>
    </SafeSegment>
  )
}

export default EncounterIgnoreButton
